import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Formik, Form} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import Yup from '../../yup';
import FormGroupField from '../admin/FormGroupField';
import FormGroupCheckbox from '../admin/FormGroupCheckbox';

const SurveyCloneSchema = Yup.object().shape({
    name: Yup.string().required(),
    settings: Yup.boolean().defined(),
    variables: Yup.boolean().defined(),
});

const SurveyCloneModal = ({isOpen, toggle, initialValues, onSubmit, submitting}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                <FormattedMessage {...messages.surveys.modals.cloneSurvey.title} />
            </ModalHeader>
            <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={SurveyCloneSchema}>
                <Form>
                    <ModalBody>
                        <FormGroupField type="text" id="scm-name" name="name"
                            label={messages.surveys.form.label.name} />
                        <label className="col-form-label"><FormattedMessage {...messages.surveys.modals.cloneSurvey.pickLabelTitle} /></label>
                        <FormGroupCheckbox id="scm-settings" name="settings" label={messages.surveys.modals.cloneSurvey.settings} />
                        <FormGroupCheckbox id="scm-variables" name="variables" label={messages.surveys.modals.cloneSurvey.variables} />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={toggle}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary" type="submit" disabled={submitting}>
                            <FormattedMessage {...messages.buttons.ok} />
                        </button>
                    </ModalFooter>
                </Form>
            </Formik>
        </Modal>
    );
};

export default SurveyCloneModal;
